import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { valueByName } from './form_utils';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import moment from 'moment';

const MultiSelectDay = props => {
  const { day, selectedDates, ...other } = props;
  const dateString = day.format('YYYY-MM-DD');
  const isSelected = selectedDates.includes(dateString);

  return (
    <PickersDay
      {...other}
      day={day}
      selected={isSelected}
    />
  );
};

export const ECMultiDateField = props => {
  const { name, label, form, defaultValue, initial, ...rest } = props;

  const dv = valueByName(initial, name) || defaultValue || [];

  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [value, setValue] = useState(dv);
  const [tempValue, setTempValue] = useState(dv);

  useEffect(() => {
    form.register(name);
    form.setValue(name, dv);
  }, [form.register]);

  const handleDayClick = date => {
    const dateString = date.format('YYYY-MM-DD');
    setTempValue(prev =>
      prev.includes(dateString) ? prev.filter(d => d !== dateString) : [...prev, dateString]
    );
  };

  const handleOpen = () => {
    setTempValue(value);
    setDatePickerOpen(true);
  };

  const handleCancel = () => {
    setTempValue(value);
    setDatePickerOpen(false);
  };

  const handleSave = () => {
    setValue(tempValue);
    form.setValue(name, tempValue);
    setDatePickerOpen(false);
  };

  const displayValue =
    value.length > 0
      ? value
          .slice()
          .sort()
          .map(d => moment(d).format('DD.MM.YYYY'))
          .join(', ')
      : '';

  return (
    <>
      <TextField
        label={label}
        name={name}
        fullWidth
        margin='dense'
        variant='outlined'
        helperText={form.formState.errors[name] && form.formState.errors[name].message}
        error={!!form.formState.errors[name]}
        value={displayValue}
        onClick={handleOpen}
        slotProps={{ input: { readOnly: true } }}
        {...rest}
      />

      <Dialog open={datePickerOpen} onClose={handleCancel} maxWidth='md'>
        <DialogTitle>Выберите даты</DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flexShrink: 0 }}>
              <DateCalendar
                onChange={handleDayClick}
                slots={{ day: MultiSelectDay }}
                slotProps={{
                  day: { selectedDates: tempValue },
                }}
              />
            </Box>
            <Divider orientation='vertical' flexItem />
            <Box sx={{ width: 200, display: 'flex', flexDirection: 'column' }}>
              <Typography variant='subtitle2' sx={{ px: 2, pt: 2, pb: 1 }}>
                Выбрано: {tempValue.length}
              </Typography>
              <List dense sx={{ overflow: 'auto', flex: 1, maxHeight: 300 }}>
                {tempValue
                  .slice()
                  .sort()
                  .map(date => (
                    <ListItem
                      key={date}
                      secondaryAction={
                        <IconButton
                          edge='end'
                          size='small'
                          onClick={() => setTempValue(prev => prev.filter(d => d !== date))}
                        >
                          <CloseIcon fontSize='small' sx={{ color: 'error.main' }} />
                        </IconButton>
                      }
                    >
                      <ListItemText
                        primary={moment(date).locale('ru').format('DD MMMM YYYY')}
                      />
                    </ListItem>
                  ))}
              </List>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Отменить</Button>
          <Button onClick={handleSave} variant='contained'>
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ECMultiDateField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  form: PropTypes.object,
  defaultValue: PropTypes.any,
  initial: PropTypes.object,
};
